import { render, staticRenderFns } from "./change-password-dialog.vue?vue&type=template&id=21b77824&scoped=true&"
import script from "./change-password-dialog.vue?vue&type=script&lang=js&"
export * from "./change-password-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b77824",
  null
  
)

export default component.exports